import { extendTheme } from '@chakra-ui/react';

export const theme = extendTheme({
  config: {
    initialColorMode: 'dark',
    useSystemColorMode: false,
  },
  fonts: {
    heading: '"Ubuntu", sans-serif',
    body: '"Ubuntu", sans-serif',
    mono: '"Ubuntu Mono", monospace',
  },
  styles: {
    global: {
      body: {
        bg: '#000000',
        color: 'white',
      },
    },
  },
  colors: {
    brand: {
      50: '#e0ffff',
      100: '#b3f5ff',
      200: '#80ebff',
      300: '#4de0ff',
      400: '#1ad6ff',
      500: '#00ccff',
      600: '#00a3cc',
      700: '#007a99',
      800: '#005266',
      900: '#002933',
    },
  },
});
